<template>
    <div class='post-price-offer-project-action'>
        <b-modal :active="true" width="1200" :canCancel="false">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Beskeder og begivenheder</p>
                </header>

                <section class="modal-card-body">
                    <div v-if="isLoading" class="has-text-centered">
                        <br>
                        <loader />
                        Indlæser beskeder
                    </div>

                    <template v-else>
                        <template v-for="element in content">
                            <message v-if="element.contentType === 'message'" :key="element.id"
                                     :message="element"
                                     :sender="conversation.sender"
                                     :addressee="conversation.addressee"
                                     :hideAvatars="true"/>

                            <div v-else class="has-text-centered">
                                <hr />

                                <p>{{$t(`projects.events.${element.type}`)}}</p>
                                <small>{{element.created_at | formatShortDateTime}}</small>

                                <hr />
                            </div>

                        </template>

                    </template>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button" @click="close" type="button">{{$t('global.actions.back')}}</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Loader from '@/global/components/Loader';
    import Message from '@/taskflex/conversations/components/Messages/Message';
    import MessageService from '@/taskflex/conversations/services/MessageService';
    import ProjectEventsService from '@/taskflex/projects/services/ProjectEventsService';

    export default {
        data() {
            return {
                messages: [],
                isLoadingMessages: false,
                projectEvents: [],
                isLoadingProjectEvents: false,
            };
        },

        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        computed: {
            content() {
                // Get messages, map to include contentType: 'message',
                const messages = this.messages.map((message) => {
                    message.contentType = 'message';
                    return message;
                });

                // Get events, filter to remove non-offer events, map to include contentType: 'message'
                const events = this.projectEvents
                    .map((event) => {
                        event.contentType = 'event';
                        return event;
                    });

                // Join the two data-sets, sort by created, asc.
                return [
                    ...messages,
                    ...events,
                ].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
            },

            conversation() {
                return this.project.conversation;
            },

            isLoading() {
                return this.isLoadingMessages || this.isLoadingProjectEvents;
            },
        },

        mounted() {
            this.loadMessages();
            this.loadProjectEvents();
        },

        methods: {
            loadMessages() {
                const options = {
                    includes: ['sender'],
                    // page: this.page,
                    // limit: this.limit,

                    // SORT BY NEWEST LAST
                    sort: [
                        {
                            key: 'created_at',
                            direction: 'asc',
                        },
                    ],

                    overrideAuth: true,
                };

                this.isLoadingMessages = true;

                MessageService.findAll(this.conversation.id, options, ({ data: { rows } }) => {
                    this.isLoadingMessages = false;
                    this.messages = rows;
                });
            },

            loadProjectEvents() {
                const options = {
                    includes: ['account'],

                    sort: [
                        {
                            key: 'created_at',
                            direction: 'asc',
                        },
                    ],
                };

                this.isLoadingProjectEvents = true;

                ProjectEventsService.findAll(this.project.id, options, ({ data: { rows } }) => {
                    this.isLoadingProjectEvents = false;
                    this.projectEvents = rows;
                });
            },

            close() {
                this.$emit('close');
            },
        },

        components: {
            Loader,
            Message,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/components/projects/ConversationModal.vue